import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { environmentComerciantes } from '@environments/environment';

@Injectable({ providedIn: 'root' })
export class ContractService {
    constructor(private http: HttpClient) { }

    createContract(json) {
        return this.http.post<any>(`${environmentComerciantes.apiUrl}/Contract/InsertOrUpdate`,json);
    }
    getContractDropDowns(){
        return this.http.get<any>(`${environmentComerciantes.apiUrl}/Contract/getContractDropDowns`);
    }
    
}